import React, { Component } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

class FeeDueValidationModal extends Component {

    feeDuesTemplate = (rowData) => {
        const amount = rowData?.feeStatus?.totalDues || 0;
        return (
            <div style={{
                color: 'red',
                fontWeight: 'bold'
            }}>
                ₹{amount.toLocaleString()}
            </div>
        );
    };

    render() {
        const { visible, onHide, onNext, studentsWithFeeDues, eligibleStudents = [] } = this.props;

        return (
            <Dialog
                visible={visible}
                modal
                // style={{ width: '90vw', maxWidth: '1000px', borderRadius: '16px', padding: 0 }}
                className="promotion-modal"
                onHide={onHide}
                header={null}
                closable={false}
                draggable={false}
                resizable={false}
                contentStyle={{ padding: 0 }}
                breakpoints={{ '960px': '90vw' }}
                 style={{ 
                    width: '90vw', 
                    maxWidth: '1000px', 
                    borderRadius: '16px', 
                    padding: 0,
                    overflow: 'hidden',
                    // backgroundColor: 'red'
                }}
            >
                <div style={{ position: 'relative', minHeight: 'auto' }}>
                    {/* Close Button */}
                    <button
                        onClick={onHide}
                        style={{
                            position: 'absolute',
                            top: 18,
                            right: 18,
                            background: 'transparent',
                            border: 'none',
                            fontSize: 22,
                            cursor: 'pointer',
                            zIndex: 2
                        }}
                        aria-label="Close"
                    >
                        &#10005;
                    </button>

                    <div className="flex flex-column align-items-center py-3 px-4">
                        {/* Info Icon - Changed from warning to info */}
                        <div className="flex justify-content-center align-items-center" style={{ marginBottom: 12 }}>
                            <span style={{
                                background: "#DBEAFE",
                                borderRadius: "50%",
                                padding: "16px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "64px",
                                height: "64px"
                            }}>
                                <span style={{ fontSize: 32 }}>
                                                                        <i className="fa fa-graduation-cap" />

                                </span>
                            </span>
                        </div>

                        <h3 className="font-bold text-center mb-3" style={{ fontSize: 22 }}>
                            Request Student Promotion
                        </h3>

                        {/* Students Table */}
                        <div className="w-full mb-3">
                            <DataTable
                                value={studentsWithFeeDues}
                                responsiveLayout="scroll"
                                showGridlines
                                className="dataTableValuesText"
                                style={{ fontSize: '14px' }}
                            >
                                <Column
                                    header="Student Name"
                                    style={{ width: "15%" }}
                                    alignHeader="center"
                                    headerClassName="text-color-secondary"
                                    bodyClassName="text-center"
                                    body={(rowData) => (
                                        <span>
                                            {`${rowData?.user_info?.firstName || ''} ${rowData?.user_info?.lastName || ''}`}
                                        </span>
                                    )}
                                />
                                <Column
                                    field="user_info.enrollmentId"
                                    header="Enrollment No."
                                    style={{ width: "15%" }}
                                    alignHeader="center"
                                    headerClassName="text-color-secondary"
                                    bodyClassName="text-center"
                                />
                                <Column
                                    field="user_info.branchName"
                                    header="Branch"
                                    style={{ width: "15%" }}
                                    alignHeader="center"
                                    headerClassName="text-color-secondary"
                                    bodyClassName="text-center"
                                />
                                <Column
                                    field="user_info.custom:board"
                                    header="Board"
                                    style={{ width: "15%" }}
                                    alignHeader="center"
                                    headerClassName="text-color-secondary"
                                    bodyClassName="text-center"
                                />
                                <Column
                                    field="user_info.custom:grade"
                                    header="Grade"
                                    style={{ width: "10%" }}
                                    alignHeader="center"
                                    headerClassName="text-color-secondary"
                                    bodyClassName="text-center"
                                />
                                <Column
                                    field="user_info.sectionName"
                                    header="Section"
                                    style={{ width: "10%" }}
                                    alignHeader="center"
                                    headerClassName="text-color-secondary"
                                    bodyClassName="text-center"
                                />
                                <Column
                                    header="Fee Due"
                                    style={{ width: "15%" }}
                                    alignHeader="center"
                                    headerClassName="text-color-secondary"
                                    bodyClassName="text-center"
                                    body={this.feeDuesTemplate}
                                />
                            </DataTable>
                        </div>

                        {/* Information Note - Changed messaging */}
                        <div className="w-full mb-3">
                            <p style={{
                                color: '#1F2937',
                                fontSize: '14px',
                                textAlign: 'left',
                                margin: 0
                            }}>
                                <strong>Note :</strong> The above students have fee dues in the present academic year. These students will also be promoted along with other students.
                            </p>

                            {/* Show total count information */}
                            <p style={{
                                color: '#059669',
                                fontSize: '14px',
                                textAlign: 'left',
                                margin: '8px 0 0 0'
                            }}>
                                <strong>Info :</strong> All {eligibleStudents.length} selected student(s) will be promoted to the next academic year.
                            </p>
                        </div>

                        {/* Buttons - Next button is always enabled now */}
                        <div className="flex justify-content-center gap-3 mt-2">
                            <Button
                                label="Next"
                                className="p-button"
                                style={{
                                    background: "#2E90FA",
                                    borderRadius: "8px",
                                    padding: "10px 32px",
                                    fontWeight: 600,
                                    fontSize: 16,
                                    color: "#fff",
                                    border: "none"
                                }}
                                onClick={onNext}
                            />
                            <Button
                                label="Cancel"
                                className="p-button-outlined"
                                style={{
                                    borderRadius: "8px",
                                    padding: "10px 32px",
                                    fontWeight: 600,
                                    fontSize: 16,
                                    border: "none",
                                    background: "#F2F4F7",
                                    color: "#344054"
                                }}
                                onClick={onHide}
                            />
                        </div>
                    </div>
                </div>
            </Dialog>
        );
    }
}

export default FeeDueValidationModal;